import React, { Component } from "react";
import { connect } from "react-redux";
import Branding from "./Branding";
import MainNav from "./MainNav";
import { withTranslation } from 'react-i18next';
import ToolBar from "../components/ToolBar";
import LoadingBar from "react-redux-loading-bar";
import { Breakpoint } from 'react-socks';

class AppHeader extends Component {
    render() {
        const { isCatalogueMode, isAppMode, showOpenpayBanner, showKlarnaBanner, allowAnonymouse } = this.props.settings;
        const isSearcPluginMode = this.props.settings.isSearcPluginMode === true; //isCatalogueMode  &&
        if (isCatalogueMode === true || isAppMode === true) {
            return (
                <header className="navbar-Catalogue">
                    <LoadingBar className="progress progress-bar" showFastActions />
                    {isSearcPluginMode !== true && <ToolBar settings={this.props.settings} />}
                </header>
            );
        }
        const { user } = this.props;
        if (allowAnonymouse === false && user.isAuthenticated !== true)
            return (
                <header className="navbar-Catalogue">
                    <LoadingBar className="progress progress-bar" showFastActions />
                </header>
            );

        return (
            <header className={showOpenpayBanner || showKlarnaBanner ? "navbar navbar-sticky navbar-second" : "navbar navbar-sticky"}>
                <Branding />
                <MainNav />
                <LoadingBar className="progress progress-bar" showFastActions />
                <ToolBar settings={this.props.settings} />
            </header>
        );
    }
}

function mapStateToProps({ user, settings }, ownProps) {
    return { user, settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, null)(AppHeader));
